/**
 * Branding defaults shared by the apply-side (`useBranding`) and the
 * settings-form preview swatches. Single source so the empty-state
 * rendering always matches what the SPA actually uses when the field
 * is blank.
 *
 * The colour values are the hex equivalents of the Aurora HSL tokens
 * defined in `aurora/tokens.css` — keep these in sync if Aurora ever
 * shifts its base hue/saturation/lightness.
 */

/** Aurora rose primary — `hsl(338, 45%, 48%)`. */
export const AURORA_PRIMARY_HEX = '#b1436c';
/** Aurora sage accent — `hsl(174, 35%, 37%)`. */
export const AURORA_ACCENT_HEX = '#3d7f79';
/** Aurora primary-active / brand-700 — `hsl(338, 45%, 36%)`. */
export const AURORA_BUTTON_HOVER_HEX = '#853251';
/** Sidebar gradient base (already hex in tokens.css). */
export const AURORA_SIDEBAR_HEX = '#1b1f33';

/**
 * The official BCS pinwheel as an inline SVG (matches BcsLogo.vue
 * exactly). Used as the default favicon when a tenant hasn't uploaded
 * one, so removing a custom favicon falls back to a recognisable
 * BCS-platform mark instead of leaving the previous icon stranded.
 */
export const BCS_PINWHEEL_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102.38 102.38">
<polygon points="51.19 51.19 51.19 0 14.99 14.99" fill="#E35B62"/>
<polygon points="51.19 51.19 102.38 51.19 87.38 14.99" fill="#0088CC"/>
<polygon points="87.38 14.99 51.19 0 51.19 51.19" fill="#DE1380"/>
<polygon points="14.99 14.99 0 51.19 51.19 51.19" fill="#FC833F"/>
<polygon points="51.19 102.38 87.38 87.38 51.19 51.19" fill="#006A8F"/>
<polygon points="102.38 51.19 51.19 51.19 87.38 87.38 102.38 51.19" fill="#05006E"/>
<polygon points="51.19 51.19 14.99 87.38 51.19 102.38" fill="#02AFAF"/>
<polygon points="0 51.19 14.99 87.38 51.19 51.19" fill="#F6C970"/>
<circle cx="51.33" cy="51.26" r="5.1" fill="#FFF"/>
<circle cx="51.33" cy="51.26" r="3.4" fill="#000054"/>
</svg>`;

/**
 * Data-URI form ready to drop into `<link rel="icon" href="...">`. We
 * URI-encode rather than base64 so the SVG stays readable in dev tools
 * and the encoded payload is shorter.
 */
export const BCS_PINWHEEL_DATA_URI =
  'data:image/svg+xml;utf8,' + encodeURIComponent(BCS_PINWHEEL_SVG);
